import React, { Component } from 'react';

import {thanksLogDB} from '../indexedDB/lovefield.js';

//アニメーション用ライブラリ
import { CSSTransition } from 'react-transition-group';

//pages
import FirstView from './pages/FirstView.js';
import AppMainLayout from './layouts/AppMainLayout.js';

export default class App extends Component {


    constructor(props) {
        super(props)
        this.state = {
            workMode:'firstView',
            // workMode:'appMain',

            componentList:[
                {component:<FirstView/>,workMode:'firstView'},
                {component:<AppMainLayout/>,workMode:'appMain'},
            ],
        }
    }

    componentDidMount() {
        const dbCheckInterval = setInterval(() => {

            if(thanksLogDB !== undefined){
                clearInterval(dbCheckInterval);
                this.setState({workMode:'appMain'});
            }
        },1000)
    
    }

    //methods
    //アロー関数にしないと、thisがundefinedになってしまう
    //参照: https://qiita.com/kilo/items/714287a3ea41b4187545
    toggleMode = () => {
        if(this.state.workMode === 'firstView'){
            this.setState({workMode: 'appMain'});
        }else{
            this.setState({workMode: 'firstView'});
        }
    }

    render() {

      const swichedComponent = (value,index) => {
          return (
              <CSSTransition
              in={this.state.workMode === value.workMode}
              timeout={1000}
              classNames="simpleFade1000"
              unmountOnExit
              mountOnEnter
              key={index}
              >
                {() => value.component}
              </CSSTransition>
          )
      };

      return (
        <div className="App">
          { this.state.componentList.map( swichedComponent ) }
        </div>
      );
    }

}

